enum AuthProtect {
  REQUIRED = 'REQUIRED',
  NOT_REQUIRED = 'NOT_REQUIRED'
}

export default AuthProtect;
